import React from 'react'

function UserTableHead() {
    return (
        <thead className='UserTableHead'>
        <tr>
            <th className="UserName">User Name</th>
            <th className="CreatedDate">Register Date</th>
            <th className="Status">Status</th>
            <th className="Roles">Roles</th>
            <th className="Actions">Actions</th>
        </tr>
        </thead>
    )
}

export default UserTableHead
